import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "section page is-flex is-fullheight is-flex-direction-row is-align-items-center is-justify-content-center" }
const _hoisted_2 = { class: "box login-box" }
const _hoisted_3 = { class: "logo-wrapper mt-2" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "w-100 center"
}
const _hoisted_6 = {
  key: 1,
  class: "w-100 center"
}
const _hoisted_7 = {
  key: 2,
  class: "w-100 form-wrapper mb-5"
}
const _hoisted_8 = {
  key: 0,
  class: "w-100"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_spin = _resolveComponent("n-spin")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_n_alert = _resolveComponent("n-alert")!
  const _component_n_input = _resolveComponent("n-input")!
  const _component_n_form_item = _resolveComponent("n-form-item")!
  const _component_n_form = _resolveComponent("n-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.logo,
          width: "226",
          height: "61"
        }, null, 8 /* PROPS */, _hoisted_4)
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_n_spin, { size: "large" })
          ]))
        : (_ctx.success)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createTextVNode(_toDisplayString(_ctx.$t('reset_password.email_has_been_sent', { email: _ctx.email })) + " ", 1 /* TEXT */),
              _createVNode(_component_router_link, { to: {name: 'login'} }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_button, {
                    size: "large",
                    type: "primary",
                    class: "mt-1"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('reset_password.back_to_login')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_ctx.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_n_alert, {
                      title: _ctx.$t('reset_password.edit.failure'),
                      type: "error"
                    }, null, 8 /* PROPS */, ["title"])
                  ]))
                : _createCommentVNode("v-if", true),
              _createVNode(_component_n_form, {
                ref: "form",
                model: _ctx.result,
                "onUpdate:model": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.result) = $event)),
                rules: _ctx.rules
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_form_item, {
                    label: _ctx.$t('reset_password.form.email_field'),
                    path: "email"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_input, {
                        size: "large",
                        value: _ctx.result.email,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.result.email) = $event)),
                        type: "email",
                        clearable: "",
                        placeholder: _ctx.$t('reset_password.form.email_field')
                      }, null, 8 /* PROPS */, ["value", "placeholder"])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["label"])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["model", "rules"]),
              _createVNode(_component_n_button, {
                size: "large",
                type: "success",
                onClick: _ctx.onSubmit
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('reset_password.send')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["onClick"])
            ]))
    ])
  ]))
}